import { MedplumClient } from "@medplum/core";
import { ChargeItem } from "@medplum/fhirtypes";

import { MEDPLUM_SEARCH_PAGE_MAX_COUNT } from "@/encounters/constants/medplum-search";
import { joinReferenceString } from "@/utils/medplum";

/**
 * Every charge captured against one encounter, voided ones included.
 *
 * Bypasses the request cache because charges are written with `executeBatch`, which does not
 * invalidate cached searches the way `createResource` does. A cached read would miss what the last
 * capture wrote — charging a procedure a second time, or sending an encounter without the charge it
 * never saw.
 *
 * Voided charges come back on purpose, and each caller decides what to do with them: the capture
 * counts them, so a charge a biller deleted is not created again, and the send skips them, so a
 * deleted line is not billed for.
 *
 * `_count` is set well above any encounter's realistic charge volume — `searchResources` returns
 * only the first page otherwise, which would silently leave later charges uncounted and unwritten.
 */
export const searchEncounterChargeItems = (
  medplum: MedplumClient,
  encounterId: string,
): Promise<ChargeItem[]> =>
  medplum.searchResources(
    "ChargeItem",
    {
      context: joinReferenceString("Encounter", encounterId),
      _count: MEDPLUM_SEARCH_PAGE_MAX_COUNT,
    },
    { cache: "no-cache" },
  );
